import axios from "axios";

// In production the API is served same-origin via a Netlify proxy
// (/classifind/api/* -> Fly backend), so the auth cookie is first-party.
// In development we talk to the local backend directly; localhost:3000 and
// localhost:8000 are same-site, so the SameSite=Lax cookie still flows.
export const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (process.env.NODE_ENV === "production"
    ? "/classifind/api"
    : "http://localhost:8000");

const client = axios.create({
  baseURL: API_BASE,
  withCredentials: true, // send/receive the auth cookie
});

// Normalize errors to a friendly message the UI can display directly.
export function apiError(error, fallback = "Something went wrong") {
  return (
    error?.response?.data?.message ||
    (error?.code === "ERR_NETWORK" ? "Can't reach the server" : fallback)
  );
}

export default client;
